export default "__VITE_ASSET__88df2261__"